import _extends from '/app/node_modules/babel-runtime/helpers/extends';
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from 'vuex';
import { CloseSessionModal } from '~/components/modals';

export default {
    components: {
        CloseSessionModal: CloseSessionModal
    },
    head: function head() {
        return {
            title: this.$store.state.dashboard.details.toolbarTitle
        };
    },
    data: function data() {
        return {
            firstname: '',
            lastname: '',
            isSuperUser: ''
        };
    },

    computed: _extends({}, mapState({
        toolbarTitle: function toolbarTitle(state) {
            return state.dashboard.details.toolbarTitle;
        },
        toolbarBackUrl: function toolbarBackUrl(state) {
            return state.dashboard.details.toolbarBackUrl;
        },
        showToolbarBackButton: function showToolbarBackButton(state) {
            return state.dashboard.details.showToolbarBackButton;
        },
        firstName: function firstName(state) {
            return state.user.firstName;
        },
        lastName: function lastName(state) {
            return state.user.lastName;
        }
    })),
    mounted: function mounted() {
        window.loading_screen.finish();
    }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"babelrc":false,"cacheDirectory":true,"presets":[["/app/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/layouts/stepped.vue
// module id = ./node_modules/babel-loader/lib/index.js?{"babelrc":false,"cacheDirectory":true,"presets":[["/app/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/layouts/stepped.vue
// module chunks = 21